import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faCheck, faCopy} from '@fortawesome/pro-solid-svg-icons';
import {copyToClipboard} from '@webmate-web-core/shared/utils/clipboard';

@Component({
    selector: 'wm-copyable-text',
    templateUrl: './copyable-text.component.html',
    styleUrls: ['./copyable-text.component.less'],
    standalone: true,
    imports: [
        FaIconComponent
    ]
})
export class CopyableTextComponent implements OnDestroy {
    @Input({required: true}) displayText!: string;
    @Input() copyText?: string;

    copied = false;

    protected readonly faCopy = faCopy;
    protected readonly faCheck = faCheck;

    private iconResetTimer?: ReturnType<typeof setTimeout>;

    constructor(private readonly cdRef: ChangeDetectorRef) {}

    copy(): void {
        copyToClipboard(this.copyText ?? this.displayText).then(() => {
            this.copied = true;
            clearTimeout(this.iconResetTimer);
            this.iconResetTimer = setTimeout(() => {
                this.copied = false;
                this.cdRef.detectChanges();
            }, 1000);

            this.cdRef.detectChanges();
        }).catch(() => {});
    }

    ngOnDestroy(): void {
        clearTimeout(this.iconResetTimer);
    }
}
